const ASSESSMENT = {
  GET_ASSESSMENTS: 'risk/assessments-player-get-history' as 'risk/assessments-player-get-history',
  GET_ASSESSMENTS_QUESTIONS: 'risk/assessments-questions-get' as 'risk/assessments-questions-get',
}

export default ASSESSMENT
